import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

export const IceIcon = ({ launcher }) => {
    if (!launcher) return null;
    return (
        <Box sx={{ width: '100%', textAlign: 'center', pt: 2, pb: 1.25 }}>
            <Link
                href="https://www.ice.com"
                aria-label="ICE home"
                sx={{ display: 'inline-block' }}
            >
                <Box
                    component="img"
                    src="ssoreact/resources/img/ice_logo_black.svg"
                    alt="ICE"
                    sx={{ height: '2.5rem', width: 'auto', display: 'block' }}
                />
            </Link>
        </Box>
    );
};
